import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "birthplace-form__inputs" }
const _hoisted_2 = { class: "bs-row birthplace-form__inputs-row" }
const _hoisted_3 = { class: "birthplace-form__input c-6 c-sm-4 c-sm2-6" }
const _hoisted_4 = { class: "birthplace-form__input-wrapper" }
const _hoisted_5 = { class: "birthplace-form__input c-6 c-sm-4 c-sm2-6" }
const _hoisted_6 = { class: "birthplace-form__input-wrapper selectbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectBox = _resolveComponent("SelectBox")!
  const _component_ModalPopup = _resolveComponent("ModalPopup")!

  return (_openBlock(), _createBlock(_component_ModalPopup, {
    class: "birthplace-form",
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isOpen) = $event)),
    closeButton: false,
    backdropStatic: true
  }, {
    default: _withCtx(() => [
      _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "birthplace-form__header" }, "Doplnění povinných údajů", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "birthplace-form__description" }, [
        _createTextVNode(" S novou podobou "),
        _createElementVNode("strong", null, "zákona o hazardních hrách"),
        _createTextVNode(" musíme mít nyní u všech hráčů na Sazka.cz doplněné "),
        _createElementVNode("strong", null, "místo a stát narození"),
        _createTextVNode(". Prosíme vás o vyplnění těchto údajů do políček níže. V případě, že nám tyto údaje nedodáte do "),
        _createElementVNode("strong", null, "1. 3. 2022"),
        _createTextVNode(", budeme váš účet muset zablokovat. "),
        _createElementVNode("a", {
          href: "/centrum-podpory/online-hrani-na-sazka-cz/muj-ucet/proc-pri-registraci-musim-uvadet-misto-a-stat-narozeni",
          target: "_blank"
        }, "Více informací")
      ], -1)),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "birthplace-form__mandatory-note" }, "Všechna pole jsou povinná", -1)),
      _createElementVNode("form", {
        class: "birthplace-form__form",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendForm && _ctx.sendForm(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "birthplace-form__input-label" }, "Město", -1)),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  required: "",
                  type: "text",
                  class: "birthplace-form__input-value",
                  name: "fname",
                  minlength: "2",
                  maxlength: "60",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.birthplaceForm.city) = $event)),
                  placeholder: "Město narození"
                }, null, 512), [
                  [_vModelText, _ctx.birthplaceForm.city]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "birthplace-form__input-label" }, "Země", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_SelectBox, {
                  class: "birthplace-form__selectbox",
                  options: _ctx.countryOptions,
                  modelValue: _ctx.birthplaceForm.country,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.birthplaceForm.country) = $event))
                }, null, 8, ["options", "modelValue"])
              ])
            ])
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "birthplace-form__notice" }, [
          _createTextVNode(" Kliknutím na Odeslat potvrzuji, že jsem četl(a)  "),
          _createElementVNode("a", {
            href: "/zpracovani-osobnich-udaju/ochrana-osobnich-udaju",
            target: "_blank",
            rel: "noreferrer noopener"
          }, "Informace o zpracování osobních údajů")
        ], -1)),
        _cache[7] || (_cache[7] = _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary birthplace-form__btn-submit"
        }, "Odeslat", -1))
      ], 32)
    ]),
    _: 1,
    __: [8,9,10]
  }, 8, ["modelValue"]))
}